require('./RASetGoalStep1.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const RAImageButton = require('components/RAComponents/commons/RAImageButton/RAImageButton');
const RAImageButtonGroup = require('components/RAComponents/commons/RAImageButtonGroup/RAImageButtonGroup');
// @ utilities
const classNames = require('classnames');
import { formatText } from 'core/i18n';
// @ components
const RASetGoalStepHeader = require('components/RAComponents/RASetGoal/RASetGoalStepHeader/RASetGoalStepHeader');
// @ constants
const { FIRST_STEP } = require('constants/RAConstants');

class RASetGoalStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleImageClicked = this.handleImageClicked.bind(this);
    }

    handleImageClicked(goalSelected) {
        this.props.onGoalSelected(goalSelected);
    }

    buildImageButtons(goalsList, initialIconState) {
        const { immSteps } = this.props;
        const goalSelectedFlagForRadio = immSteps.getIn([FIRST_STEP, 'goalSelectedFlagForRadio']);
        let isSelected, extraClassForGoalWrapper;

        const content = goalsList.map((content, index) => {
            const title = content.get('title');
            const id = content.get('id');
            const extraClass = !initialIconState ? 'icon' : '';

            isSelected = content.get('isSelected');

            if (!goalSelectedFlagForRadio) {
                isSelected = goalSelectedFlagForRadio;
                extraClassForGoalWrapper = 'ra-set-goal-step1__icon';
            }

            return (
                <RAImageButton
                    extraClass={extraClass}
                    extraClassForGoalWrapper={extraClassForGoalWrapper}
                    iconType={id}
                    id={id}
                    isSelected={isSelected}
                    key={`${title}-${index}`}
                    label={title}
                />
            );
        });

        return content;
    }

    render() {
        const { immSteps, disabled } = this.props;
        const goalsList = immSteps.getIn([FIRST_STEP, 'goals']);
        const validStep = immSteps.getIn([FIRST_STEP, 'goalSelected']);
        let content;

        if (goalsList && !goalsList.isEmpty()) {
            content = this.buildImageButtons(goalsList, validStep);
        }

        const goalStepClass = classNames('ra-set-goal-step1', { 'ra-set-goal-step1--disabled': disabled });

        return (
            <div className={goalStepClass}>
                <RASetGoalStepHeader
                    title={formatText('raSetGoal-step1HeaderTitle')}
                    description={formatText('raSetGoal-step1HeaderDescription')}
                    active={validStep}
                />
                <div className="row">
                    <div className="col-md-12">
                        <div className="ra-set-goal-step1__col-header">
                            <RAImageButtonGroup onChange={this.handleImageClicked}>{content}</RAImageButtonGroup>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RASetGoalStep1.propTypes = {
    active: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    immSteps: PropTypes.object.isRequired,
    onGoalSelected: PropTypes.func,
    selectedGoal: PropTypes.func,
};

RASetGoalStep1.defaultProps = {
    disabled: false,
};

module.exports = RASetGoalStep1;
